import React from 'react';
import './SideNav.scss';
import BaseButton from 'base-components/BaseButton/BaseButton';
import { useNavigate, NavLink } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { mainMenu } from 'utils/consts';

const SideNav: React.FC = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleSignOut = () => {
      console.log("User signed out");
      logout();
      navigate("/login");
    };

    return (
        <nav className="sidebar">
            <h1 className="sidebar__title">AVM</h1>
            <ul>               
                {mainMenu.map((el) => (
                    <li key={el.label}>
                        <NavLink to={el.route} >
                            {el.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
            <BaseButton
                className="sidebar__button"
                type="submit"
                color="primary"
                data-testid="login-button"
                onClick={handleSignOut}
            >
                <span>
                    Выйти
                </span>
            </BaseButton>
        </nav>
    );
};

export default SideNav;
